import { useState } from 'react'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorMessage } from 'services/apiError'
import MainButton from 'components/Buttons/MainButton'
import emailValidator from 'validators/emailValidator'
import { Formik } from 'formik'

import {
  Form,
  FormField,
  InfoText,
  Input,
  WarningText,
  ErrorContainer
} from '../styles'

export default function RequestCodeForm ({
  userType = 'business',
  onSubmit: handleSubmitForm
}) {
  const [errorMessage, setErrorMessage] = useState (null)

  return (
    <Formik
      validationSchema={emailValidator}
      initialValues={{
        'email': ''
      }}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          setSubmitting (true)

          const apiEndpoint = userType === 'company'
            ? '/verify_account/companies'
            : '/verify_account/businesses'

          await cutileiApi.post (apiEndpoint, values)

          setSubmitting (false)
          // O e-mail sobe para o passo seguinte: a troca do codigo agora e conferida
          // contra o dono que o pediu, em vez de procurar o codigo no sistema inteiro.
          handleSubmitForm (values.email)
        } catch (error) {
          setSubmitting (false)
          setErrorMessage (getApiErrorMessage (error))
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        isSubmitting,
        handleChange,
        handleBlur,
        handleSubmit
      }) => (
        <Form>
          <InfoText>
            Insira seu endereço de e-mail e te enviaremos um código para redefinir sua senha
          </InfoText>
          <FormField>
            <Input
              type='email'
              placeholder='E-mail'
              value={values.email}
              onChange={handleChange ('email')}
              onBlur={handleBlur ('email')}
            />
            {touched.email && errors.email && (
              <WarningText>
                {errors.email}
              </WarningText>
            )}
          </FormField>
          {errorMessage && (
            <ErrorContainer>
              <p>{errorMessage}</p>
            </ErrorContainer>
          )}
          <MainButton
            label='Enviar código'
            onClick={handleSubmit}
            disabled={isSubmitting}
            loading={isSubmitting}
            width={140}
          />
        </Form>
      )}
    </Formik>
  )
}
